import { render } from "./OnBoardingLoader.vue?vue&type=template&id=a04273cc&scoped=true"
import script from "./OnBoardingLoader.vue?vue&type=script&lang=js"
export * from "./OnBoardingLoader.vue?vue&type=script&lang=js"

import "./OnBoardingLoader.vue?vue&type=style&index=0&id=a04273cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04273cc"]])

export default __exports__